/**
 * Swap a logo path for its refreshed version, using the live swaps each layout sets from LogoRefreshComposer.
 * Use the monochrome version where the logo sits in a list of other brands' logos.
 * @param {string} path
 * @param {boolean} monochrome
 */
export default function(path = '', monochrome = false) {
    const paths = (window.logoRefreshPaths || {})[monochrome ? 'monochrome' : 'colour'] || {};

    return paths[path] || path;
}
